import { render, staticRenderFns } from "./DiscountCodeTable.vue?vue&type=template&id=5b598a8f&"
import script from "./DiscountCodeTable.vue?vue&type=script&lang=js&"
export * from "./DiscountCodeTable.vue?vue&type=script&lang=js&"
import style0 from "./DiscountCodeTable.vue?vue&type=style&index=0&id=5b598a8f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports